import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { handleError } from './Functions';
import { InfoTable } from './InfoTable';

export function TableModal({ setShow, name, parentId, getEndpoint, columns, columnNames }) {
    const [data, setData] = useState<any>();

    useEffect(() => {
        if(parentId)
            getEndpoint(parentId)
                .then(dat => setData(dat))
                .catch(err => handleError(err));
    }, [parentId])// eslint-disable-line react-hooks/exhaustive-deps

    const handleCancel = () => {
        setData(null)
        setShow(false)
    }

    if(!data) return null;

    return (
        <Dialog
            open={true}
            onClose={handleCancel}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">{name}</DialogTitle>
            <DialogContent>
                <InfoTable
                    rowData={data}
                    columns={columns}
                    columnNames={columnNames} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}